<template>
    <div ref="animationContainer" class="animation-container">
        <div class="animation-relative">
            <img :src="data.background.data" class="background" />
            <img :id="iconId" :src="data.icon.data" class="icon" :alt="data.icon.name" />
            <!-- <div :id="textIconId" :style="{ color: data.textColorIcon }" class="text text-icon"
                :class="{ 'text-preview': isPreview }"></div> -->
            <div :id="textMainId" :style="{ color: data.textColorMain }" class="text text-main"
                :class="{ 'text-preview': isPreview }"></div>
            <div :id="textDetailId" :style="{ color: data.textColorDetail }" class="text text-detail"
                :class="{ 'text-preview': isPreview }">
            </div>
        </div>
    </div>
</template>

<script>

import { gsap } from 'gsap'
import { TextPlugin } from "gsap/TextPlugin"
import getEnv from '@/utils/env'
gsap.registerPlugin(TextPlugin)
export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        conf: {
            type: String,
            required: true
        },
        isPreview: {
            type: Boolean,
            required: false
        },
        isMobileDevice: {
            type: Boolean,
            required: false
        },
        idx: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            id: -1,
            icon: {
                name: "",
                data: "",
            },
            background: {
                name: "",
                data: "",
            },
            textIcon: "",
            textMain: "",
            textDetail: "",
            textColorIcon: "",
            textColorMain: "",
            textColorDetail: "",
            animationContainer: null,
            bubbleWidth: '30%',
            bubbleLeft: '35%',
            bubbleTop: '35%',
            isPortraitMode: false,
            dataCount: parseInt(getEnv('VUE_APP_DATA_COUNT')) || 3,
            dataScale: parseFloat(getEnv('VUE_APP_DATA_SCALE')) || 0.7,
            animationSpeed: parseFloat(getEnv('VUE_APP_ANIMATION_SPEED')) || 1,
            showTime: parseInt(getEnv('VUE_APP_SHOW_TIME')) * 1000 || 20000,
            confInternal: "pos0"
        }
    },
    computed: {

        textMainId() {
            return `textMain_${this.data.id}`
        },
        // textIconId() {
        //     return `textIcon_${this.data.id}`
        // },
        iconId() {
            return `icon_${this.data.id}`
        },
        textDetailId() {
            return `textDetail_${this.data.id}`
        }
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize)
    },
    mounted() {
        this.isPortraitMode = window.screen.orientation.type.includes('portrait')
        this.confInternal = this.conf
        if (this.isMobileDevice && this.isPortraitMode) {
            this.bubbleWidth = '200px'
            this.bubbleLeft = '35%'
            this.bubbleTop = '50%'
            this.dataCount = 3
            this.dataScale = 0.7
            this.confInternal = ['pos0', 'pos1', 'pos2', 'pos3', 'pos4'][this.idx % this.dataCount]
        }
        else {
            this.bubbleWidth = '30%'
            this.bubbleLeft = '35%'
            this.bubbleTop = '35%'
        }

        this.updateBubbleStyles()
        this.animateElement()

        window.addEventListener('resize', this.handleResize)
    },


    methods: {
        reset() {
            this.updateBubbleStyles()
            this.animateElement()
        },
        updateBubbleStyles() {
            if (this.$refs.animationContainer) {
                this.$refs.animationContainer.style.setProperty('--bubble-width', this.bubbleWidth)
                this.$refs.animationContainer.style.setProperty('--bubble-left', this.bubbleLeft)
                this.$refs.animationContainer.style.setProperty('--bubble-top', this.bubbleTop)
            }
        },
        handleResize() {
            if (this.isMobileDevice && window.screen.orientation.type.includes('portrait')) {
                this.bubbleWidth = '40%'
                this.bubbleLeft = '35%'
                this.bubbleTop = '50%'
            } else {
                this.bubbleWidth = '30%'
                this.bubbleLeft = '35%'
                this.bubbleTop = '35%'
            }
            this.isPortraitMode = window.screen.orientation.type.includes('portrait')
            //this.animateElement()
            this.updateBubbleStyles()
        },
        calculateSpacein(pos) {
            let totalSpacing = 90 - this.dataCount * (30 * this.dataScale)
            let spacing = totalSpacing / (this.dataCount - 1)
            return pos * ((30 * this.dataScale) + spacing) - ((30 - (30 * this.dataScale)) / 2) + 5
        },
        animateToPos(timeline, pos, isMobileDevice) {
            let animationProperties = {
                delay: this.animationSpeed * 2,
                top: isMobileDevice && this.isPortraitMode ? (pos % 3) * 30 + "%" : "-5%",
                left: isMobileDevice && this.isPortraitMode ? "10%" : "0%",
                scale: this.dataScale,
                duration: this.animationSpeed * 1.5
            }

            if (!isMobileDevice) {
                animationProperties.left = this.calculateSpacein(pos) + "%"
            }
            return timeline
                .to(`#${this.textIconId}`, {
                    duration: this.animationSpeed * 1,
                    text: this.data.textIcon
                })
                .to(`#${this.textIconId}`, {
                    duration: this.animationSpeed * 1,
                    scale: this.dataScale,
                    x: "0%",
                    y: "-222%"
                })
                .to(`#${this.iconId}`, {
                    duration: this.animationSpeed * 0.7,
                    scale: this.dataScale,
                    x: "0%",
                    y: "-50%"
                }, "<")
                .to(`#${this.textMainId}`, {
                    duration: this.animationSpeed * 0.5,
                    text: this.data.textMain
                })
                .to(`#${this.textDetailId}`, {
                    duration: 0,
                    text: this.data.textDetail
                }, "<")
                .to(this.$refs.animationContainer, animationProperties)
        },
        animateElement() {
            this.$el.style.visibility = 'hidden'


            // RESET GSAP!
            gsap.killTweensOf(this.$refs.animationContainer)
            gsap.ticker.lagSmoothing(false);

            const mainTimeline = gsap.timeline()

            // Reset position!!
            if (this.isMobileDevice) {
                mainTimeline.to(this.$refs.animationContainer, { 
                    scale: 1, 
                    left: "5%",
                    top: "35%",
                    duration: 1 }
                )   
            } else {
            mainTimeline.to(this.$refs.animationContainer, { 
                    scale: 1, 
                    left: "35%",
                    top: "35%",
                    duration: 1 }
                )   
            }


            let delay = Math.floor(this.idx / this.dataCount) * (this.animationSpeed * this.showTime)
            setTimeout(() => {
                mainTimeline.to(this.$refs.animationContainer, { 
                    autoAlpha: 1, 
                    duration: this.animationSpeed * 1.5 }
                )
                switch (this.confInternal) {
                case 'pos0':
                    this.animateToPos(mainTimeline, 0, this.isMobileDevice)
                    mainTimeline.then(() => { this.$emit('animationComplete') })
                    break
                case 'pos1':
                    this.animateToPos(mainTimeline, 1, this.isMobileDevice)
                    mainTimeline.then(() => { this.$emit('animationComplete') })
                    break
                case 'pos2':
                    this.animateToPos(mainTimeline, 2, this.isMobileDevice)
                    mainTimeline.then(() => { this.$emit('animationComplete') })
                    break
                case 'pos3':
                    this.animateToPos(mainTimeline, 3, this.isMobileDevice)
                    mainTimeline.then(() => { this.$emit('animationComplete') })
                    break
                case 'pos4':
                    this.animateToPos(mainTimeline, 4, this.isMobileDevice)
                    mainTimeline.then(() => { this.$emit('animationComplete') })
                    break                    
                }
            }, this.idx * this.animationSpeed * 10000 + delay) 
           
        }
    }
}

</script>

<style lang="scss" scoped>
.animation-relative {
    position: relative;
    width: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.animation-container {
    position: absolute;
    display: flex;
    z-index: 4;
    width: var(--bubble-width, 20%);
    left: var(--bubble-left, 20%);
    top: var(--bubble-top, 20%);
}

.background {
    width: 100%;
}

.icon {
    position: absolute;
    top: 25%;
    left: 25%;
    width: 50%;
    z-index: 2;
}

.text {
    text-align: center;
    word-wrap: break-word;
}

.text-icon {
    position: absolute;
    top: 50%;
    z-index: 3;
    font-weight: bold;
    font-size: 2.5vw;
    width: 100%;
    margin-top: 32px;
}

.text-icon.text-preview {
    font-size: 1.25vw;
}

.text-main {
    position: absolute;
    top: 44%;
    z-index: 3;
    font-weight: bold;
    font-size: 4vw;
    width: 100%;
    line-height: 100%;
}

.text-main.text-preview {
    font-size: 2vw;
}

.text-detail {
    position: absolute;
    top: 64%;
    left: 10%;
   // transform: translateX(-50%);
    z-index: 3;
    width: 80%;
    font-size: 1.6vw;
}

.text-detail.text-preview {
    font-size: 0.75vw;
}

@media (max-width: 600px) {
    .text-detail {
   //     top: 55%;
        left: 10%;
        width: 160%;
        font-size: 4.5vw;
    }

    .background {
        width: 180%;
        left: 20%
    }

    .icon {
   //     top: 15%;
        left: 40%;
      width: 100%;
        z-index: 2;
    }

    .text-icon {
  //      top: 40%;
        font-size: 5.5vw;
 //       width: 100%;
       // left: 50%;
    }

    .text-main {
   //     top: 41%;
        font-size: 7vw;
        width: 180%;
        left: 0%;
    }
}

@media (max-width: 400px) {
    .background {
        width: 140%;
        left: 20%
    }

    .text-detail {
        left: 10%;
        width: 120%;
        font-size: 4.5vw;
    }

    .background {
        width: 140%;
        left: 30%
    }

    .icon {
        left: 20%;
        width: 100%;
        z-index: 2;
    }

    .text-icon {
        font-size: 5.5vw;
    }

    .text-main {
        font-size: 7vw;
        width: 140%;
        left: 0%;
    }

}

</style>
